import * as React from 'react';

import { Steps } from 'antd';
import { ButtonType, HtmlType, Space } from 'farmhub-ui-core';

import { CButton } from 'components';
import { GlobalStyle } from 'styled';

import { MobileWrapper, ContentMobileStep } from './styles';

const { Step } = Steps;

interface CollaboratorCreatePageContentDesktopProps {
  handleSubmitStep: (e: number) => void;
  handleNextStep: () => any;
  ListStep: any[];
  isSubmitting: boolean;
  currentTab: number;
  handleChangeCurrentStep: (e: number) => void;
}

const CollaboratorCreatePageContentMobile = ({
  handleSubmitStep,
  handleNextStep,
  ListStep,
  isSubmitting,
  currentTab,
  handleChangeCurrentStep,
}: CollaboratorCreatePageContentDesktopProps): JSX.Element => (
  <MobileWrapper>
    <Steps
      current={currentTab}
      labelPlacement="vertical"
      style={{ width: 'fit-content' }}
    >
      <Step
        style={{ cursor: 'pointer' }}
        title="Thông tin"
        onClick={() => handleChangeCurrentStep(0)}
      />
      <Step
        style={{ cursor: 'pointer' }}
        title="Danh mục"
        onClick={() => handleChangeCurrentStep(1)}
      />
      <Step
        style={{ cursor: 'pointer' }}
        title="Chứng nhận"
        onClick={() => handleSubmitStep(2)}
      />
    </Steps>
    <Space height={18} />
    <ContentMobileStep>
      {ListStep[currentTab]}
      <Space height={12} />
      <CButton
        htmlType={HtmlType.Submit}
        loading={isSubmitting}
        type={ButtonType.Primary}
        width="100%"
        onClick={handleNextStep}
      >
        Xác nhận
      </CButton>
      <div id="recaptcha-container" />
    </ContentMobileStep>
    <GlobalStyle />
  </MobileWrapper>
);

export default CollaboratorCreatePageContentMobile;
